
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { SelectWrap, SelectContainer, SelectValue, SelectIcon, SelectType, SelectOptions, SelectOption, SelectOptionsContainer } from './SelectCodesExternes.styled';
import CloseIcon from '@mui/icons-material/Close';
import Axios from '../../../axios-proas'
import { FormGroup, FormInput, FormLabel, TelInput, FormSelect } from '../../../styles/Common';

function SelectCodesExternes({ value, setValue, onChange, options,index, width, close, deleteItem }) {
    const [isOpen, setIsOpen] = useState(false);
    const [codesInternes, setCodesInternes] = useState([]);
    const [typeCodesInternes, setTypeCodesInternes] = useState();
    const handleClick = (value) => {
        setIsOpen(false);
      
        onChange(value, index);

    }
    useEffect(() => {  
        if (isOpen && typeCodesInternes != null && typeCodesInternes!="") {
            Axios.get(`/api/campagnes/codeinternes?typeCodeInterne=${typeCodesInternes}`).then(res => {
                console.log(res?.data)
                setCodesInternes(res?.data)
            }).catch(response => {
                notyf.error("Une erreur s'est produite")
            })
    }else {
            setCodesInternes(options)
    }
    }, [isOpen, typeCodesInternes])
    return (
        <SelectWrap width={width}>
            <SelectContainer width={"100%"} onClick={() => setIsOpen(!isOpen)}>
                <SelectValue>
                    {options.filter(a => a.id == value)[0]?.libelle}
                </SelectValue>
                <SelectIcon>
                    {
                        isOpen ? <KeyboardArrowUpIcon className="ICDBlue" />
                            : <KeyboardArrowDownIcon className="ICDBlue" />
                    }
                </SelectIcon>
            </SelectContainer>
           
            {
                isOpen && (
                    <SelectOptionsContainer width={"260px"}>
                        <>
                            <SelectType>
                                <FormSelect
                                    style={{ textAlign: "left"} }
                                    id="typecodeInterneId"
                                    name="typecodeInterneId"
                                    value={typeCodesInternes ?? ""}
                                    onChange={(e) => setTypeCodesInternes(e.target.value)}
                                >
                                    <option key="in" value={""}>-- Sélectionner un type --</option>
                                    <option key="in" value={1}>Sexe</option>
                                    <option key="in" value={2}>Civilité</option>
                                    
                               
                                    <option key="in" value={3}>Lien familial</option>
                                    <option key="in" value={4}>Raison du départ</option>
                                    <option key="in" value={5}>Situation familiale</option>
                                    <option key="in" value={6}>Situation professionnelle</option>
                                    <option key="in" value={7}>Ressources</option>
                                    <option key="in" value={8}>Catégorie socio-professionnelle</option>
                                    <option key="in" value={9}>Nationalité</option>
                                    <option key="in" value={10}>Prestation familiale</option>

                                </FormSelect>
                            </SelectType>

                            <SelectOptions>
                            {
                                codesInternes?.map((item, index) => (
                                    <SelectOption
                                        key={index}
                                        onClick={(e) => handleClick(item?.id)}
                                    >
                                        {item?.libelle}
                                    </SelectOption>
                                )
                                )
                                }
                            </SelectOptions>
                        </>
                    </SelectOptionsContainer>
                )
            }
        </SelectWrap>
    );
}

export default SelectCodesExternes;
